import { type Ref } from 'vue';

import { useNotificationStore } from '@/entities/Notification';
import { documentApi } from '@/entities/Document';

import { useDocumentDelete } from '@/shared/lib';

interface UseDocumentListTableDeleteOptions {
  selectedDocuments: Ref<number[]>;
  deselectAllDocuments: () => void;
  onDelete: (deletedIds: number[]) => void;
}

export function useDocumentListTableDelete(options: UseDocumentListTableDeleteOptions) {
  const { selectedDocuments, deselectAllDocuments, onDelete } = options;

  const { fetchApprovalCount, fetchVerificationCount } =
    useNotificationStore();

  const { handleDelete, handleOpenDeleteConfirmation, openDeleteConfirmation } =
    useDocumentDelete({
      selectedDocuments,
      deselectAllDocuments,
      onDelete,
      deleteDocuments: documentApi.bulkDeleteDocumentRevisions,
      onAfterDelete: async () => {
        await fetchApprovalCount();
        await fetchVerificationCount();
      },
    });

  return {
    handleDelete,
    handleOpenDeleteConfirmation,
    openDeleteConfirmation,
  };
}
